'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.hourAgo;


// WEBPACK FOOTER //
// ./~/sugar-date/number/hourAgo.js